<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('select_type_verification') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" offset="3" sm="4" offset-sm="4" md="4" offset-md="4" class="text-center">
        <p class="caption line-height-regular">
          {{ $t('verification_code_instruction') }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" offset="3" sm="4" offset-sm="4" md="4" offset-md="4" class="text-center">
        <v-card class="mx-auto elevation-5" @click="verifyPhone()">
          <v-card-text class="d-flex flex-column align-center">
            <v-img src="@/assets/images/svg/phone.svg" height="48" width="64" contain />
            <div class="mt-2">
              {{ $t('call') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" offset="3" sm="4" offset-sm="4" md="4" offset-md="4" class="text-center">
        <v-card class="mx-auto elevation-5" @click="verifySms()">
          <v-card-text class="d-flex flex-column align-center">
            <v-img src="@/assets/images/svg/mail.svg" height="48" width="64" contain />
            <div class="mt-2">
              {{ $t('sms') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  registerV2 as registerV2Customer
} from '@/api/auth'
export default {
  data() {
    return {
      email: '',
      phone: '',
      data_verification: {},
      form: {
        key_pre_register: '',
        otp_type: 1
      }
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async verifySms() {
      try {
        this.form.otp_type = 1
        this.form.key_pre_register = this.data_verification.key_pre_register
        const { data } = await registerV2Customer(this.form)
        this.data_verification.value.id = data.data.id
        this.$store.state.loading_axios = false
        this.$store.dispatch('save_type_verification', 'sms')
        this.$store.dispatch('data_verification', this.data_verification)
        this.$router.push({ name: 'verification_otp', query: { redirect: this.$route.query.redirect }}).catch(() => {})
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async verifyPhone() {
      this.$router.push({ name: 'call_verification', query: { redirect: this.$route.query.redirect }}).catch(() => {})
    }
  }
}
</script>
